module.exports = __webpack_public_path__ + "img/18.1c8b764b.jpg";